import React, { FC, useCallback, useEffect } from 'react'
import { MainHeadline, SmallHeadline, TopHeadline } from 'components/Typography'
import styles from 'styles/components/template.module.scss'
import { Spacer } from 'components/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTags } from 'reducks/tag/operations'
import { State } from 'index'
import { getTags } from 'reducks/tag/selectors'
import { FlexRow } from 'components/Flex'
import { BlueButton, NavButton } from 'components/Button'
import { push } from 'connected-react-router'
import { TagCardList } from 'components/Card'

const TagsTemplate: FC = () => {
  const dispatch = useDispatch()
  const tags = useSelector((state: State) => getTags(state))

  const goToCreatePage = useCallback(() => {
    dispatch(push('/admin/master/tags/create'))
  }, [])

  useEffect(() => {
    dispatch(fetchTags())
  }, [])

  return (
    <div className={styles.standard}>
      <Spacer size={28} />
      <MainHeadline headline={'登録されているオススメポイント'} />
      <Spacer size={28} />
      <FlexRow justifyContent={'between'}>
        <SmallHeadline label={`全${tags.length}件`} />
        <BlueButton
          label={'新しく登録する'}
          onClick={goToCreatePage}
          size={'xsmall'}
          startIconPath={'/icon/white/add.svg'}
          type={'main'}
        />
      </FlexRow>
      <Spacer size={12} />
      <TagCardList tags={tags} />
      <Spacer size={12} />
      <FlexRow justifyContent={'end'}>
        <BlueButton
          label={'新しく登録する'}
          onClick={goToCreatePage}
          size={'xsmall'}
          startIconPath={'/icon/white/add.svg'}
          type={'main'}
        />
      </FlexRow>
      <Spacer size={48} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/admin/shops'} />
      <Spacer size={72} />
    </div>
  )
}

export default TagsTemplate
